import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 500, md: 900, lg: 1200, xl: 1536 },
  },
  overrides: {
    MuiInputBase: {
      root: {
        '&.MuiOutlinedInput-root': {
          // Your custom styles for MuiOutlinedInput-root here
          // For example, to change the background color and border radius:
          backgroundColor: '#fefefe',
          borderRadius: '4px',
        },
      },
    },
  },
  palette: {

    base: {
      rothko1: '#8B8C95',
      rothko2: '#4E4C56',
      rothko3: '#3F3E44',
      rothko4: '#2A2A2F',
      rothko5: '#EAEBEF',
      rothko6: '#CBCDD3',
      rothko7: '#67656C',
      rothko8: '#0A0A0A'
    },

    reds: {
      rothko1: '#C7271E',
      rothko2: '#A21C27',
      rothko3: '#E95D4C',
      rothko4: '#F18467',
    },

    blues: {
      rothko1: '#FEFEFF',
      rothko2: '#3E4D80',
      rothko3: '#2A2D48',
      rothko4: '#9C9EB7',
    },

    text: {
      primary: '#0A0A0A',
      light: '#FEFEFF',
      dark: '#0A0A0A',
      // error: '#A21C27'
    },

    error: {
      main: '#A21C27'
    },

    primary: {
      main: '#3E4D80'
    },

    secondary: {
      main: '#0A0A0A'
    },

    light: {
      main: '#FEFEFF'
    },

    border: {
      main: '#2A2A2F'
    },

    background: {
      main: '#EAEBEF'
    }

  },

  components: {
    MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: '#EAEBEF',
            margin: 0,
            padding: 0,
            height: '100%',
            width: '100%'
          },
        }
      },
    MuiButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'contained', color: 'primary' },
              style: {
                width: '100%',
                height: '30px',
                borderRadius: '2px',
                backgroundColor: '#67656C',
                color: '#FEFEFF',
                '&:hover': {
                  backgroundColor: '#8B8C95',
                },
              },
            },
            {
              props: { variant: 'contained', color: 'secondary' },
              style: {
                backgroundColor: '#3E4D80',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#9C9EB7',
                },
              },
            },
          ],
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          alignItems: 'justifyContent',
          width: '100%',
          height: '30px',
          borderRadius: '4px',
          paddingTop: '0px',
          paddingBottom: '0px',
          color: '#0A0A0A',
          '&:focus': {
            color: '#2A2A2F',
          },
        },
        select: {
          // alignItems: 'justifyContent',
          alignContent: 'center',
          paddingTop: '0px',
          paddingBottom: '0px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          width: '100%',
          height: '30px',
          borderRadius: '4px',
          backgroundColor: 'white'
        },
        input: {
          paddingTop: '0px',
          paddingBottom: '0px',
          paddingLeft: '8px'
        }
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          width: '100%',
          height: '30px',
          borderRadius: '4px',
          backgroundColor: 'white'
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginRight: 0,
          marginLeft: 0,
          variants: [
            {
              props: { variant: 'primary' },
              style: {
                color: '#2A2A2F',
              },
            },
            {
              props: { variant: 'error' },
              style: {
                color: '#A21C27',
              },
            },
          ],
        },
        label: {
          fontSize: '9px',
        }
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '10px',
          variants: [
            {
              props: { variant: 'primary' },
              style: {
                color: '#2A2A2F',
              },
            },
            {
              props: { variant: 'error' },
              style: {
                color: '#A21C27',
              },
            },
          ],
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          marginRight: 0,
        },
        thumb: {
          backgroundColor: '#3E4D80',
        },
        track: {
          backgroundColor: '#A21C27',
        },
        switchBase: {
          '&.Mui-checked': {
            color: '#3E4D80',
            '& + .MuiSwitch-track': {
              backgroundColor: '#0bd00b', // Light green when on
            },
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          maxHeight: 300
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          height: '30px',
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
            backgroundColor: '#EAEBEF',
          },
          '&.Mui-selected': {
            backgroundColor: '#d5d7f8',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#b9bbd9',
            },
          },
        }
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2A2A2F',
        }
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          fontSize: '10px',
          variants: [
            {
              props: { variant: 'primary' },
              style: {
                backgroundColor: '#67656C',
              },
            },
            {
              props: { variant: 'error' },
              style: {
                backgroundColor: '#efa4a2',
              },
            },
          ],
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'toolbar', color: 'primary' },
              style: {
                color: '#FEFEFF',
                '&:hover': {
                  color: '#FFFFFF',
                  backgroundColor: '#3E4D80'
                },
              }
            }
          ]
        }
      },
    },
  },

  shape: {
    borderRadius: 2
  },

  typography: {
    fontFamily: 'Roboto Condensed, Arial, sans-serif',
    fontSize: 10,
  },
});

export default theme